import { useCallback } from "react";
import {
  NavigateOptions,
  To,
  useNavigate as useRouterNavigate,
} from "react-router-dom";

import { useUnsavedChangesContext } from "../context/UnsavedChangesContext";

export const useGuardedNavigate = () => {
  const navigate = useRouterNavigate();
  const { confirmLeaveAll } = useUnsavedChangesContext();

  return useCallback(
    async (to: To, options?: NavigateOptions) => {
      const canLeave = await confirmLeaveAll();
      if (!canLeave) {
        return false;
      }

      navigate(to, options);
      return true;
    },
    [navigate, confirmLeaveAll]
  );
};
